import CompanyLeaderboards from "./CompanyLeaderboards";

const CompanyHardcoreLeaderboards = ({ container }) => {
  return <CompanyLeaderboards container={container} mode="hardcore" />;
};

export default CompanyHardcoreLeaderboards;
